/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import { Button } from "@mui/material";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { arenaRoomActions } from "../../arena/redux/actions";
import CircleLoading from "../../common/components/CircleLoadding";
import NoDataComponent from "../../common/components/NoData";

import { TCommonState } from "../../common/utils/type";
import IconArrowRight from "../assets/icons/IconArrowRight";
import { accountActions } from "../redux/actions";
import { compareTwoGrade } from "../utils/constant";
import { TAccountState } from "../utils/types";

const AccountArenaInfo = ({ memberHid }) => {
  const dispatch = useDispatch();
  const [openSubject, setOpenSubject] = useState<number[]>([]);
  const { isLoadingAchievement, extraInfo, infoAccount } = useSelector(
    (state: { account: TAccountState }) => state.account
  );
  const handleGetExtraInfo = () => {
    dispatch(accountActions.handleGetExtraInfo(memberHid));
  };
  const dataUser = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const grade = useSelector((state: { commonNew: TCommonState }) => state.commonNew.grade);
  const router = useRouter();

  const handleDirectListRoom = () => {
    router.push(`/${grade}/thi-online?tab=phong-thi`);
    dispatch(arenaRoomActions.handleOpenModalCreatePost(memberHid));
  };

  const listParentId = extraInfo?.arena_subjects?.reduce((arr: number[], element) => {
    if (!arr?.includes(element?.parent_id)) {
      arr.push(element?.parent_id);
    }
    return arr.sort((a, b) => b - a);
  }, []);
  const checkShowBtnCombat = (item) => {
    if (
      dataUser?.member?.pub_id !== infoAccount?.pub_id &&
      compareTwoGrade(grade, infoAccount?.grade) &&
      infoAccount?.grade === item?.parent_title
    ) {
      return true;
    }
    return false;
  };
  const handleOpenSubject = (item) => {
    if (openSubject.includes(item)) {
      setOpenSubject(openSubject.filter((id) => id !== item));
    } else setOpenSubject([...openSubject, item]);
  };
  useEffect(() => {
    if (!extraInfo || extraInfo?.memberHid !== memberHid) {
      handleGetExtraInfo();
    }
  }, []);
  return (
    <div>
      {isLoadingAchievement ? (
        <div className="flex w-full justify-center">
          <CircleLoading />
        </div>
      ) : extraInfo?.arena_subjects?.length === 0 ? (
        <NoDataComponent />
      ) : (
        <div>
          <div className="text-[15px]">
            {listParentId?.map((item) => (
              <React.Fragment key={item}>
                <div className="w-full my-2 border-b-gray border-b">
                  <button
                    type="button"
                    className="flex items-center w-full justify-between py-2.5"
                    onClick={() => handleOpenSubject(item)}
                  >
                    <span>{extraInfo?.arena_subjects?.find((e) => e?.parent_id === item)?.parent_title}</span>
                    <span className={`${openSubject.includes(item) && "rotate-90"}`}>
                      <IconArrowRight />
                    </span>
                  </button>
                </div>
                {openSubject.includes(item) &&
                  extraInfo?.arena_subjects
                    .filter((ele) => openSubject.includes(ele.parent_id) && ele.parent_id === item)
                    .map((ele) => (
                      <div
                        className={`ml-6 py-2.5 border-b  flex items-center justify-between ${"border-b-gray"}`}
                        key={ele.parent_id}
                      >
                        <span className="w-2/4 line-clamp-1">{ele.subject_title}</span>
                        <div className="flex flex-row flex-nowrap items-center md:w-2/4 sm:w-2/4 justify-end">
                          <span
                            className={`sm:mx-2 md:mx-0 line-clamp-1 ${
                              checkShowBtnCombat(ele) ? "w-[70px] flex text-right pr-2" : "float-right"
                            }`}
                          >
                            <FormattedMessage id="account.number.top" values={{ num: ele.num_of_times }} />
                          </span>
                          {checkShowBtnCombat(ele) && (
                            <Button
                              className="normal-case bg-green-gradient text-white sm:text-[10px] md:text-[13px] font-[500] h-[24px] rounded-[16px] px-1.5"
                              onClick={handleDirectListRoom}
                            >
                              <FormattedMessage id="account.btn.combat" />
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountArenaInfo;
